<script>
import date from './date/dateInput.vue';
import Vue from 'vue';
export default Vue.extend(date);
</script>
